var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteWhiteBoxed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5H18C23.2467 0.5 27.5 4.7533 27.5 10V18C27.5 23.2467 23.2467 27.5 18 27.5H10C4.7533 27.5 0.5 23.2467 0.5 18V10C0.5 4.7533 4.7533 0.5 10 0.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.296 5C16.5227 5 17.5187 5.94667 17.5187 7.10933V7.564H19.7773C21.004 7.564 22 8.51067 22 9.67333V11.4333H20.5187V20.8907C20.5187 22.0533 19.5213 23 18.296 23H9.704C8.47733 23 7.48133 22.0533 7.48133 20.8907V11.4333H6V9.67333C6 8.51067 6.99733 7.564 8.22267 7.564H10.48V7.10933C10.4813 5.94667 11.48 5 12.704 5H15.296ZM19.0373 11.4333H8.96267V20.8907C8.96267 21.2773 9.296 21.5933 9.704 21.5933H18.296C18.7053 21.5933 19.0373 21.2787 19.0373 20.8907V11.4333ZM15 13V21H13V13H15ZM18 13V21H16V13H18ZM12 13V21H10V13H12ZM19.7773 8.97067H8.22267C7.81333 8.97067 7.48133 9.28533 7.48133 9.67333V10.028H20.5187V9.67333C20.5187 9.28667 20.1853 8.97067 19.7773 8.97067ZM15.2973 6.40667H12.7027C12.2933 6.40667 11.9613 6.72133 11.9613 7.10933V7.564H16.036V7.10933C16.036 6.72267 15.7027 6.40667 15.2947 6.40667H15.2973Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 9.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhiteBoxed);
export default __webpack_public_path__ + "static/media/delete-white-boxed.e46d3df6aa79318621b8b36f6676bea6.svg";
export { ForwardRef as ReactComponent };